import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { ActionType } from '@models/widget/action-type.enum';
import { CompanyService } from '@services/my-insurance/company.service';
import { NavigationService } from '@services/navigation.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-loyalty-banner',
  templateUrl: './loyalty-banner.component.html',
  styleUrls: ['./loyalty-banner.component.scss']
})
export class LoyaltyBannerComponent implements OnInit {

  policyInfo:any;
  isLegacy: boolean;
  showCompany: string;

  constructor(
    private navService: NavigationService,
    private companyService: CompanyService
  ) { }

  ngOnInit(): void {
   this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    });
  }

  goToLearnMore(){
    this.navService.saveCurrentAction(ActionType.DiscoverRewards);
    window.open("https://www.mapfreinsurance.com/my-mapfre-rewards/", '_blank');
  }

  getCompany(policies) {
    return policies.find(policy =>(policy.company?.companyName === 'ACIC' || policy.company?.companyName === 'TW'));
  }

}
